<template>
	<div class="aa">
		
		<zongSou></zongSou>
		<div class="wrap">
			<div class="qiebox" >
				<div v-for="item in navList" class="qieli" :class="{'active': item.id == navIndex}" @click="navTap(item)">
					{{item.name}}
					<img src="../../assets/images/xia_03.png" class="xaisan" alt="">
				</div>
			</div>
			<div class="hotbox animate__animated animate__fadeInUp" v-if="navIndex === 1">
				<div class="hotli" @click="$router.push('/projectNeed/releaseNeed')">
					<img src="../../assets/images/ha_03.png"class="hotpic"/>
					<div class="hottxt">
						发布项目
					</div>
				</div> 
				<div class="hotli" style="background: #FFFAF4;" @click="$router.push('/zyTools/createTools')">
					<img src="../../assets/images/computerIndex.png"class="hotpic" />
					<div class="hottxt">
						发布工具
					</div>
				</div>
				<div class="hotli" @click="$router.push('/zyTools/createQZtools')"> 
					<img src="../../assets/images/findGenuis.png"class="hotpic"/>
					<div class="hottxt">
						工具求助
					</div>
				</div>
				<div class="hotli" @click="$router.push('/solutionDetail/releaseSolution')">
					<img src="../../assets/images/ha_03.png"class="hotpic"/>
					<div class="hottxt">
						发布方案
					</div>
				</div> 
				<div class="hotli" style="background: #FFFAF4;" @click="$router.push('/solutionDetail/createQz')">
					<img src="../../assets/images/computerIndex.png"class="hotpic" />
					<div class="hottxt">
						方案求助
					</div>
				</div>
				<div class="hotli" @click="$router.push('/proIndex/productService')"> 
					<img src="../../assets/images/findGenuis.png"class="hotpic"/>
					<div class="hottxt">
						发布服务
					</div>
				</div>
				<div class="hotli" @click="$router.push('/productService/proCreateQz')">
					<img src="../../assets/images/ha_03.png"class="hotpic"/>
					<div class="hottxt">
						服务求助
					</div>
				</div> 
				<div class="hotli" style="background: #FFFAF4;" @click="$router.push('/userCenter/createCompany')">
					<img src="../../assets/images/computerIndex.png"class="hotpic" />
					<div class="hottxt">
						新建企业
					</div>
				</div>
				<div class="hotli" @click="$router.push('/geniusClub')"> 
					<img src="../../assets/images/findGenuis.png"class="hotpic"/>
					<div class="hottxt">
						找牛人
					</div>
				</div>
				<div class="hotli" @click="$router.push('/userCenter')">
					<img src="../../assets/images/ha_03.png"class="hotpic"/>
					<div class="hottxt">
						个人中心
					</div>
				</div> 
				<div class="hotli" style="background: #FFFAF4;" @click="$router.push('/userCenter/pthd/myMessage')">
					<img src="../../assets/images/computerIndex.png"class="hotpic" />
					<div class="hottxt">
						我的消息
					</div>
				</div>
				<div class="hotli" @click="$router.push('/userCenter/drafts')"> 
					<img src="../../assets/images/findGenuis.png"class="hotpic"/>
					<div class="hottxt">
						我的草稿
					</div>
				</div>
				
			</div>
			<div class="xinbox animate__animated animate__fadeInLeft" v-if="navIndex === 2">
				<div class="xinli"  @click="$router.push('/allsearchRefine/xmxqC')">
					<div class="xintop ">
						<img src="../../assets/images/xina_03.png" class="xinpic" alt="">
						<div class="xintitle">
							最新需求
						</div>
					</div>
					<div class="xintxt oneline" v-for="(item,index) in newsList.projectneed">
						{{item.title}}
					</div>
					<!-- <div class="xintxt oneline">
						最新项目内容,最新项目内容最新项目内容,最新项目内容
					</div> -->
				</div>
				<div class="xinli" @click="$router.push('/ResourceTools')">
					<div class="xintop">
						<img src="../../assets/images/xinb_03.png" class="xinpic" alt="">
						<div class="xintitle">
							资源工具
						</div>
					</div>
					<div class="xintxt oneline"v-for="(item,index) in newsList.instrument">
						{{item.title}}
					</div>

				</div>
				<div class="xinli"  @click="$router.push('/searchIndex/Solution')">
					<div class="xintop">
						<img src="../../assets/images/xinc_03.png" class="xinpic" alt="">
						<div class="xintitle">
							成功案例
						</div>
					</div>
					<div class="xintxt oneline"v-for="(item,index) in newsList.scheme">
						{{item.title}}
					</div>
				</div>
				<div class="xinli" @click="$router.push('/proIndex/productService')">
					<div class="xintop">
						<img src="../../assets/images/xind_03.png" class="xinpic" alt="">
						<div class="xintitle">
							产品市场
						</div>
					</div>
					<div class="xintxt oneline"v-for="(item,index) in newsList.product">
						{{item.title}}
					</div>
				</div>
				<div class="xinli" @click="$router.push('/geniusClub')">
					<div class="xintop">
						<img src="../../assets/images/xine_03.png" class="xinpic" alt="">
						<div class="xintitle">
							认识牛人
						</div>
					</div>
					<div class="xintxt oneline"v-for="(item,index) in newsList.user">
						{{item.nickname}}
					</div>
				</div>
			</div>
			
			<div class="xinbox animate__animated animate__lightSpeedInLeft" v-if="navIndex === 3">
				<div class="buli" @click="goto(`/projectNeed/releaseNeed`)">
					<img src="../../assets/images/xinf_03.png" class="bupic" alt="">
					<div class="xintitle">
						项目需求池
					</div>
				</div>
				<div class="buli" @click="goto(`/zyTools/createTools`)">
					<img src="../../assets/images/xinb_03.png" class="bupic" alt="">
					<div class="xintitle">
						资源工具池
					</div>
				</div>
				<div class="buli" @click="goto(`/solutionDetail/releaseSolution`)">
					<img src="../../assets/images/xinc_03.png" class="bupic" alt="">
					<div class="xintitle">
						解决方案池
					</div>
				</div>
				<div class="buli" @click="goto(`/productService/createProductService`)">
					<img src="../../assets/images/xind_03.png" class="bupic" alt="">
					<div class="xintitle">
						产品服务池
					</div>
				</div>
			</div>
		</div>
		
		<div class="fenbfg">
			<div class="wrap">
				<div class="fennei">
					<img src="../../assets/images/yin_03.png" class="fenpic" alt="">
					<div class="fentitle animate__animated animate__bounceInLeft" >
						分享优秀
						<span>工具</span>
						丰富你的工具箱
					</div>
				</div>
			</div>
		</div>
		<div class="wrap">
			<div class="xubox">
				
				<div :class="['xuli',hoverActive == 1?'activeLi':''] " @click="goto(`/allsearchRefine/xmxqC`)" @mouseenter="hoverActive = 1">
					<img src="../../assets/images/hc_05.png" class="xupic"/>
					<div class="zhe  animate__animated animate__fadeInLeft" v-show="hoverActive == 1">
						<div class="xudetail">
							项目需求池介绍
							项目需求池介绍
							项目需求池介绍
							项目需求池介绍
							项目需求池介绍
							项目需求池介绍
							项目需求池介绍
							项目需求池介绍
							项目需求池介绍
						</div>
					</div>
					<div class="xunei">
						<div class="xunum">01</div>
						<div class="xutitle">
							项目需求池
						</div>
						<img  src="../../assets/images/brr_06.png" class="xurr"/>
					</div>
				</div>
				<div :class="['xuli',hoverActive == 2?'activeLi':''] " @click="goto(`/ResourceTools`)"   @mouseenter="hoverActive = 2">
					<img src="../../assets/images/hd_05.png" class="xupic"/>
					<div class="zhe animate__animated animate__fadeInLeft" v-show="hoverActive == 2">
						<div class="xudetail">
							资源工具池介绍
							资源工具池介绍
							资源工具池介绍
							资源工具池介绍
							资源工具池介绍
							资源工具池介绍
							资源工具池介绍
							资源工具池介绍
							资源工具池介绍
						</div>
					</div>
					<div class="xunei">
						<div class="xunum">02</div>
						<div class="xutitle">
							资源工具池
						</div>
						<img  src="../../assets/images/brr_06.png" class="xurr"/>
					</div>
				</div>
				<div :class="['xuli',hoverActive == 3?'activeLi':''] "  @click="goto(`/searchIndex/Solution`)"   @mouseenter="hoverActive = 3">
					<img src="../../assets/images/he_05.png" class="xupic"/>
					<div class="zhe animate__animated animate__fadeInLeft" v-show="hoverActive == 3">
						<div class="xudetail">
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
						</div>
					</div>
					<div class="xunei">
						<div class="xunum">03</div>
						<div class="xutitle">
							解决方案池
						</div>
						<img  src="../../assets/images/brr_06.png" class="xurr"/>
					</div>
				</div>
				<div :class="['xuli',hoverActive == 4?'activeLi':''] "  @click="goto(`/searchIndex/productService`)"  @mouseenter="hoverActive = 4">
					<img src="../../assets/images/hf_05.png" class="xupic"/>
					<div class="zhe animate__animated animate__fadeInLeft" v-show="hoverActive == 4">
						<div class="xudetail">
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
						</div>
					</div>
					<div class="xunei">
						<div class="xunum">04</div>
						<div class="xutitle">
							产品服务池
						</div>
						<img  src="../../assets/images/brr_06.png" class="xurr"/>
					</div>
				</div>
				<div :class="['xuli',hoverActive == 5?'activeLi':''] "  @click="goto(`/geniusClub`)"   @mouseenter="hoverActive = 5">
					<img src="../../assets/images/hg_05.png" class="xupic"/>
					<div class="zhe animate__animated animate__fadeInLeft" v-show="hoverActive == 5">
						<div class="xudetail">
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
							解决方案池介绍
						</div>
					</div>
					<div class="xunei">
						<div class="xunum">05</div>
						<div class="xutitle">
							牛人俱乐部
						</div>
						<img  src="../../assets/images/brr_06.png" class="xurr"/>
					</div>
				</div>
				<!-- <div style="display: block;">
					<div class="bg bg-active"></div>
					<div class="bg"></div>
					<div class="bg"></div>
					<div class="bg"></div>
									
					<div class="main">
					    <ul style="display: flex;">
					        <li class="li-active"><div><p>英雄联盟</p></div></li>
					        <li><div><p>穿越火线</p></div></li>
					        <li><div><p>王者荣耀</p></div></li>
					        <li><div><p>使命召唤</p></div></li>
					    </ul>
					</div>
				</div> -->

			</div>
		</div>
	</div>
	
</template>

<script>
	import zongSou from '../../components/zongSou.vue'
	export default {
		data() {
			return {
				// 下拉框
				hoverActive:1,
				options: [{
					value: '1',
					label: '项目'
				}, {
					value: '2',
					label: '资源'
				}, {
					value: '3',
					label: '方案'
				}, {
					value: '4',
					label: '产品'
				}, {
					value: '5',
					label: '人才'
				}],
				value: '',
				// 热门切换
				searchWord:'',
				navIndex: 1,
				navList: [{
						id: 1,
						name: '热门&常用'
					}, {
						id: 2,
						name: '我要找'
					}, {
						id: 3,
						name: '我要发布'
					}
				],
				newsList:[]
			}
		},
		components:{
			zongSou
		},
		mounted() {
			 let lis = document.querySelectorAll('.main li');
			    /*获取所有的bg*/
			    let bgs = document.querySelectorAll('.bg');
			    /*遍历所有li标签,这里使用的是forEach循环*/
			    /*里面的item是lis里面的值,index是下标*/
			    /*这里面还有一个箭头函数,箭头函数的作用就是能够让this自动指向的问题*/
			    lis.forEach((item,index)=>{
			        /*给每个li绑定鼠标悬浮事件*/
			        item.onmouseover = () => {
			            /*清除所有样式,为了让点击之后的li样式跟随*/
			            lis.forEach((el,i) => {
			                el.className = '';
			                bgs[i].classList.remove('bg-active');
			            });
			            /*给激活之后的li赋予激活的样式*/
			            item.className = 'li-active';
			            /*激活背景图片*/
			            bgs[index].classList.add('bg-active');
			        }
			    });
	
		},
		created(){
			this.getIndexNews()
		},
		methods: {
			async getIndexNews(){
				const index =await this.$api.getIndexNews()
				this.newsList = index.data
			},
			// 热门切换
			goto(url){
				this.$router.push(url)
			},
			checkSearch(e){
				console.log(this.value);
			},
			navTap(item) {
				this.navIndex = item.id
			},
		}
	}
</script>
<style scoped>
	.xudetail{
		width: 100%;
		height: 40%;
		position: absolute;
		top:24%;
		padding: 15px;
		box-sizing: border-box;
		color:#fff;
		overflow: hidden;
	}
	.zhe{
		position: absolute;
		background: rgba(0, 0, 0, .8);
		width:100%;
		height: 100%;
		top: 0;
		left:0;
	}
	
	.activeLi{
		position: relative;
		overflow: hidden;
	}
</style>
<style  lang="less">
	
	 #inp{
		background-color: #1b1b1b !important;
		width: 150px !important;
		height: 60px !important;
		color: #ffffff !important;
		border: none !important;
		font-size: 18px !important;
	}
	
</style>